import { render, staticRenderFns } from "./IncomingCall.vue?vue&type=template&id=44ab013e&scoped=true&"
import script from "./IncomingCall.vue?vue&type=script&lang=js&"
export * from "./IncomingCall.vue?vue&type=script&lang=js&"
import style0 from "./IncomingCall.vue?vue&type=style&index=0&id=44ab013e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ab013e",
  null
  
)

export default component.exports